import FastModal from 'components/FastModal';
import ElementPrefixId from 'constants/elementPrefixId';
import {useIntl} from 'react-intl';
import {useDispatch} from 'react-redux';
import {hideTypedModal} from 'stores/actions/typedModalAction';
import style from './ModalHumidifierDisconnected.module.scss';

function ModalHumidifierDisconnected() {
  const dispatch = useDispatch();
  const {formatMessage} = useIntl();

  const content = (
    <div id={`${ElementPrefixId.MODAL_HUMIDIFIER_DISCONNECTED}-container`} className={style.container}>
      <span className={style.description}>{formatMessage({id: 'modal.humidifier.disconnected.text'})}</span>
    </div>
  );

  const handleClickClose = () => {
    dispatch(hideTypedModal());
  };

  const buttons = [
    {
      className: 'btn-lg',
      style: 'primary',
      text: formatMessage({id: 'modal.humidifier.disconnected.firstButton'}),
      handlerClick: handleClickClose,
    },
  ];

  return (
    <FastModal
      show
      header={formatMessage({id: 'modal.humidifier.disconnected.title'})}
      content={content}
      btnAction={buttons}
      size="md"
    />
  );
}

export default ModalHumidifierDisconnected;
